// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
 providedIn: 'root'
})

export class Auth {

  //private apiUrl = 'http://localhost/activenotify/handlers/authenticate.php'; // Replace with your API URL
  private apiUrl = environment.apiUrl + '/handlers/authenticate.php';
  //private apiUrl = 'http://www.activenotify.com/handlers/authenticate.php'; // Replace with your API URL

  constructor(private http: HttpClient) { }

  login(username: string | null, password: string | null) {
    return this.http.post(`${this.apiUrl}`, JSON.stringify({ username: username, password: password }))
          .pipe(
                  tap((response: any) => {
                    let user = response;
                    var stat = response["status"];
                    if (stat == "error")
                    {
                      return response;
                    }

                    // Handle successful login, e.g., store token
                    localStorage.setItem('currentUser', JSON.stringify(user));
                  }),
                  catchError((error) => {
                    // Handle login error
                    return throwError(() => error);
                  })
                );
    }

  logout(): void {
    // Handle logout, e.g., remove token
    localStorage.removeItem('currentUser');
  }

  isLoggedIn(): boolean {
    // Simple check if token exists
    return !!localStorage.getItem('currentUser');
  }
}
